import { createFileRoute } from '@tanstack/react-router'
import { CreditCapsPage } from '@/features/account/pages/credits/credit-caps-page'

/** D2 — Per-member caps. */
export const Route = createFileRoute('/_ws/w/$workspaceId/credits/caps')({
  component: CreditCapsPage,
})
